import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {isArray, map} from 'lodash';
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';

import TagList from './tag-list';
import {CategoryList, MovieSubThemeList, TVSubThemeList, AdultSubThemeList} from '../catalog/catalog-constants';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

class Subtheme extends Component {
    state = {
        subThemeSelection: 0,
    };

    buildGenreTag = (label, value, category) => ({genreName: label, genreValue: value, category});

    renderGenreTag = tag => (
        <div style={{whiteSpace: 'no-wrap'}}>
            <Button
                className={
                    tag.category == 'MOVIE'
                        ? 'p-button-success p-button-rounded'
                        : tag.category == 'ADULT'
                        ? 'p-button-danger p-button-rounded'
                        : 'p-button-warning p-button-rounded'
                }
                label={tag.category}
            />
            {'  '}
            {tag.genreName}
        </div>
    );

    handleSubThemeChange = e => {
        this.setState({subThemeSelection: e.target.value});
    };

    render() {
        const {id, handleUpdateSubTheme, values} = this.props;
        const {subThemeSelection} = this.state;

        return (
            <div>
                <Dropdown
                    className="criteria-form--subtheme-type"
                    filterPlaceholder="Select a SubTheme"
                    id={`subThemeType${id}`}
                    options={
                        isArray(CategoryList)
                            ? CategoryList.map((category, index) => ({
                                  label: category.label,
                                  value: index,
                              }))
                            : []
                    }
                    showClear={false}
                    style={{leftMargin: '1em', margin: '5px', width: '100px'}}
                    value={subThemeSelection}
                    onChange={this.handleSubThemeChange}
                />
                <TagList
                    buildCustomTag={this.buildGenreTag}
                    filter={true}
                    filterBy="label,value"
                    filterPlaceholder={
                        subThemeSelection != null ? `${CategoryList[subThemeSelection].label} genre` : ''
                    }
                    handleUpdateTag={handleUpdateSubTheme}
                    id={id}
                    options={
                        CategoryList[subThemeSelection].label == 'Movie'
                            ? map(MovieSubThemeList, movieGenre => ({
                                  label: movieGenre.label,
                                  value: movieGenre.value,
                                  category: 'MOVIE',
                              }))
                            : CategoryList[subThemeSelection].label == 'Adult'
                            ? map(AdultSubThemeList, adultGenre => ({
                                  label: adultGenre.label,
                                  value: adultGenre.value,
                                  category: 'ADULT',
                              }))
                            : map(TVSubThemeList, tvGenre => ({
                                  label: tvGenre.label,
                                  value: tvGenre.value,
                                  category: 'TVENT',
                              }))
                    }
                    renderCustomTag={this.renderGenreTag}
                    values={values}
                />
            </div>
        );
    }
}

Subtheme.propTypes = {
    handleUpdateSubTheme: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    values: PropTypes.array,
};

export default Subtheme;
